<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Solicitud órdenes físicas {{ secuencialVisible }}</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>

  <div class="d-flex my-xl-auto right-content align-items-center gap-2 flex-wrap">
    <button class="btn btn-light top-action-btn" type="button" (click)="limpiarPantalla()">Nueva solicitud</button>
    <button class="btn btn-secondary top-action-btn" type="button" (click)="guardarSolicitud()" [disabled]="guardandoSolicitud || generandoBlocks">
      {{ guardandoSolicitud ? 'Guardando...' : 'Guardar solicitud' }}
    </button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible premium-hero">
      <div class="card-body hero-body">
        <div>
          <p class="hero-kicker">Producción de órdenes físicas</p>
          <h5 class="hero-title mb-1">Configuración y distribución de blocks</h5>
          <p class="hero-subtitle mb-0">Define parámetros, genera blocks y distribuye precios 2D antes de guardar.</p>
        </div>
        <div class="hero-metrics">
          <div class="metric-card">
            <span class="metric-label">Secuencia</span>
            <b class="metric-value">{{ secuencialVisible }}</b>
          </div>
          <div class="metric-card">
            <span class="metric-label">Blocks</span>
            <b class="metric-value">{{ totalBlocksGenerados }}</b>
          </div>
          <div class="metric-card">
            <span class="metric-label">Asignado</span>
            <b class="metric-value">{{ porcentajeAsignacion }}%</b>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-12">
    <div class="card overflow-visible config-card">
      <div class="card-body">
        @if (cargandoInicial) {
          <div class="text-center py-4">
            <div class="spinner-grow" role="status"></div>
            <p class="mt-2 mb-0">Cargando configuración de la solicitud...</p>
          </div>
        }

        @if (!cargandoInicial) {
          <div>
            <div class="alert alert-secondary custom-alert" role="alert">
              Recuerde que para generar los blocks el total debe ser mínimo 25 y múltiplo de 25.
            </div>
            <div class="row g-3 align-items-end">
              <div class="col-xl-2 col-lg-6">
                <label class="form-label">Total de órdenes</label>
                <input type="number" min="25" class="form-control" [(ngModel)]="totalGenerar">
              </div>
              <div class="col-xl-3 col-lg-6">
                <label class="form-label">Prefijo secuencial</label>
                <div class="control-inline">
                  <select class="form-control" [(ngModel)]="prefijoSecuencia" (change)="onPrefijoChange()">
                    <option value="">Seleccione...</option>
                    @for (prefijo of prefijosSecuenciales; track prefijo) {
                      <option [value]="prefijo.start">
                        {{ prefijo.start }}
                      </option>
                    }
                  </select>
                  <button class="btn btn-outline-secondary" type="button" (click)="agregarPrefijoSecuencial()">Agregar</button>
                </div>
              </div>
              <div class="col-xl-2 col-lg-6">
                <label class="form-label">Siguiente secuencia</label>
                <input type="text" class="form-control readonly-field" [value]="secuencialVisible" readonly>
              </div>
              <div class="col-xl-2 col-lg-6">
                <label class="form-label">Tipo precio</label>
                <select class="form-control" [(ngModel)]="tipoPrecio" (change)="onTipoPrecioChange()">
                  <option value="">Seleccione...</option>
                  @for (tipo of tipoPrecios; track tipo) {
                    <option [value]="tipo.COD_TIPPREC">
                      {{ tipo.DES_TIPPREC }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-xl-3 col-lg-8">
                <label class="form-label">Proveedor</label>
                <div class="control-inline">
                  <select class="form-control" [(ngModel)]="proveedorTemporal">
                    <option value="">Seleccione...</option>
                    @for (proveedor of proveedores; track proveedor) {
                      <option [value]="proveedor.COD_PROV">
                        {{ proveedor.NOM_PROV }}
                      </option>
                    }
                  </select>
                  <button class="btn btn-outline-secondary" type="button" (click)="agregarProveedor()">Agregar</button>
                </div>
              </div>
              <div class="col-xl-12 col-lg-4">
                <label class="form-label">Responsable</label>
                <input type="text" class="form-control readonly-field" [value]="responsable" readonly>
              </div>
            </div>
            @if (proveedoresSeleccionados.length > 0) {
              <div class="provider-tags">
                @for (proveedor of proveedoresSeleccionados; track proveedor; let i = $index) {
                  <button class="provider-tag" type="button" (click)="removerProveedor(i)">
                    <span>{{ proveedor.NOM_PROV }}</span>
                    <i class="fa fa-times"></i>
                  </button>
                }
              </div>
            }
            <div class="actions-row">
              <button class="btn btn-secondary create-blocks-btn" type="button" (click)="crearBlocks()" [disabled]="generandoBlocks || guardandoSolicitud">
                {{ generandoBlocks ? 'Procesando...' : 'Crear blocks' }}
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  @if (blocksGenerados.length > 0) {
    <div class="col-xl-12">
      <div class="row row-sm">
        <div class="col-xl-5">
          <div class="card overflow-visible detail-card h-100">
            <div class="card-header">
              <h5 class="card-title mb-0">Detalle de blocks</h5>
              <p class="text-muted mb-0">Visualización de secuenciales generados por block.</p>
            </div>
            <div class="card-body">
              <div class="kpi-row">
                <div><span>Total:</span> <b>{{ totalBlocksGenerados }}</b></div>
                <div><span>Disponibles:</span> <b>{{ totalBlocksDisponibles }}</b></div>
              </div>
              <div class="table-responsive d-none d-md-block">
                <table class="table table-bordered table-striped align-middle premium-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>N. Block</th>
                      <th>Secuenciales asignados</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (block of blocksGenerados; track block; let i = $index) {
                      <tr>
                        <td>{{ i + 1 }}</td>
                        <td><span class="block-chip">{{ block.BLOCK }}</span></td>
                        <td>{{ (block.SECUENCIALES || []).join(', ') }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="mobile-list d-md-none">
                @for (block of blocksGenerados; track block; let i = $index) {
                  <article class="mobile-card">
                    <div class="mobile-card__head">
                      <span class="mobile-index">#{{ i + 1 }}</span>
                      <span class="block-chip">{{ block.BLOCK }}</span>
                    </div>
                    <div class="mobile-card__content">
                      <span class="mobile-label">Secuenciales asignados</span>
                      <p class="mobile-text mb-0">{{ (block.SECUENCIALES || []).join(', ') }}</p>
                    </div>
                  </article>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-7">
          <div class="card overflow-visible detail-card h-100">
            <div class="card-header header-actions">
              <div>
                <h5 class="card-title mb-0">Asignación de precios 2D</h5>
                <p class="text-muted mb-0">Distribuya la totalidad de blocks generados.</p>
              </div>
              <button class="btn btn-secondary btn-sm add-item-btn" type="button" (click)="agregarDetalleOrden()">
                Agregar item
              </button>
            </div>
            <div class="card-body">
              <div class="progress-wrap mb-3">
                <div class="progress">
                  <div class="progress-bar bg-success" role="progressbar" [style.width.%]="porcentajeAsignacion"></div>
                </div>
                <small>{{ totalBlocksAsignados }} de {{ totalBlocksGenerados }} blocks asignados</small>
              </div>
              <div class="table-responsive d-none d-md-block">
                <table class="table table-bordered table-striped align-middle premium-table">
                  <thead>
                    <tr>
                      <th>N. de blocks</th>
                      <th>Precio 2D</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of detallePrecios2D; track item; let i = $index) {
                      <tr>
                        <td>
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            [(ngModel)]="item.numeroBlocks"
                            (change)="validarNumeroBlocks(i)">
                        </td>
                        <td>
                          <select class="form-control" [(ngModel)]="item.precios2D">
                            <option value="">Seleccione...</option>
                            @for (precio of preciosDisponibles; track precio) {
                              <option [value]="precio.VAL_PREC">
                                {{ precio.VAL_PREC | currency:'USD':'symbol':'1.2-2' }}
                              </option>
                            }
                          </select>
                        </td>
                        <td>
                          <button class="btn btn-danger btn-sm" type="button" (click)="eliminarDetalleOrden(i)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    }
                    @if (detallePrecios2D.length === 0) {
                      <tr>
                        <td colspan="3" class="text-center text-muted">
                          Seleccione el tipo de precio y genere blocks para empezar la asignación.
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              @if (detallePrecios2D.length > 0) {
                <div class="mobile-list d-md-none">
                  @for (item of detallePrecios2D; track item; let i = $index) {
                    <article class="mobile-card">
                      <div class="mobile-card__head">
                        <span class="mobile-index">Item {{ i + 1 }}</span>
                        <button class="btn btn-danger btn-sm" type="button" (click)="eliminarDetalleOrden(i)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                      <div class="mobile-form-grid">
                        <div>
                          <label class="form-label">N. de blocks</label>
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            [(ngModel)]="item.numeroBlocks"
                            (change)="validarNumeroBlocks(i)">
                        </div>
                        <div>
                          <label class="form-label">Precio 2D</label>
                          <select class="form-control" [(ngModel)]="item.precios2D">
                            <option value="">Seleccione...</option>
                            @for (precio of preciosDisponibles; track precio) {
                              <option [value]="precio.VAL_PREC">
                                {{ precio.VAL_PREC | currency:'USD':'symbol':'1.2-2' }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    </article>
                  }
                </div>
              }
              @if (detallePrecios2D.length === 0) {
                <div class="mobile-empty d-md-none">
                  Seleccione el tipo de precio y genere blocks para empezar la asignación.
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
